import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./plano-contas-matriz-listar/plano-contas-matriz-listar.module').then(m => m.PlanoContaMatrizListarModule) },
        { path: 'inserir', data: { breadcrumb : 'Inserir' }, loadChildren: () => import('./plano-contas-matriz-inserir/plano-contas-matriz-inserir.module').then(m => m.PlanoContaMatrizInserirModule) },
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./plano-contas-matriz-editar/plano-contas-matriz-editar.module').then(m => m.PlanoContaMatrizEditarModule) }
    ])],
    exports: [RouterModule]
})
export class PlanoContaMatrizAppRoutingModule { }